import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { ToastrService } from 'ngx-toastr';
import { SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND } from 'src/app/shared/constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'inbound-awb',
  templateUrl: './inbound-awb.component.html',
  styleUrls: ['./inbound-awb.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class InboundAwbComponent implements OnInit, OnChanges {
  isOpen: boolean = false;
  shipments: any = [];
  isValidAwb: boolean = true;
  shipmentNumber: string;
  pinObject: any = {
    waybillNumber: "",
    origin: "",
    productGroup: "",
    status: ""
  };
  OTPObject: any = {
    waybillNumber: "",
    origin: "",
    productGroup: ""
  };
  @Output() inboundShipments = new EventEmitter();
  @Input() changing;
  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings'));
  isMultiCurrenciesForInbound = false;
  isMultiCurrenciesVisible = false;
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
   
  constructor(private shipmentDetails: ReceiptService, private toaster: ToastrService,private translate: TranslateService) {
  }

isInboundValidationOnDestEnabled = JSON.parse(sessionStorage.getItem('branchSettings')).find(m => m.Key == 44).Value == "True";
  //search inbound shipment by number
  serachAwbNumber() {
    this.shipmentNumber = this.shipmentNumber.trim();
    if (this.shipmentNumber != null && this.shipmentNumber != undefined && this.shipmentNumber != "") {
      var shipmentsNumbers = this.shipmentNumber.split('\n');
      shipmentsNumbers = shipmentsNumbers.filter(x => x != "");
      var AWBNumbers = '';
      for (var i = 0; i < shipmentsNumbers.length; i++) {
        AWBNumbers += shipmentsNumbers[i] + (i + 1 < shipmentsNumbers.length ? ',' : '');
      }
      this.shipmentDetails.getShipmentDetails(JSON.stringify(AWBNumbers), 1, this.isInboundValidationOnDestEnabled,(res) => {
        this.shipmentNumber = '';
        var returnedShipments = res as any[];
        returnedShipments.forEach((x) => {
          if (x.Shipment != null) {
            var index = res.findIndex(r => r == x)
            if (x.Shipment.IsSmart) {
              res[index].Shipment.validated = false;
            }
            else {
              res[index].Shipment.validated = true;
            }

            if (x.Shipment.OTPShipmentProperty != null) {
              res[index].Shipment.OTPValidated = false;
            }
            else {
              res[index].Shipment.OTPValidated = true;
            }
          }
         
        })
        this.updateShipmentsAsPerNewFlow(res);
        var inValidShiments = res.filter((x) => { return x.IsReady == false });
        if (inValidShiments.length > 0) {
          for (var i = 0; i < inValidShiments.length; i++) {
            this.toaster.error(`${this.translate.instant('pages.createReceiptPage.inboundAwb.shipmentNotReady',{
              inValidShimentsNumber: inValidShiments[i].Number
            })}`)
          }
        }
        if (this.shipments.length > 0) {
          this.inboundShipments.emit(this.shipments);
        }
        this.change();

      }, (err) => {
      });
    }
    else {
      if (this.shipments.length == 0) {
        this.inboundShipments.emit(null);
        this.isOpen = false;
      }
      else {
        this.toaster.error(`${this.translate.instant('pages.createReceiptPage.validShipmentNumber')}`);
      }
    }
  }

  updateShipmentsAsPerNewFlow(res: any) {
    let setting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND);
    if (setting != undefined) {
      this.isMultiCurrenciesForInbound = setting.Value == 'True';
    }
    
    if (this.isMultiCurrenciesForInbound) {
      // New Flow
      this.shipments = [];
      var ResShipments = res.filter((x) => { return x.Shipment != null });
      if (ResShipments.length > 0) {
        for (var i = 0; i < ResShipments.length; i++) {
          let retShipments = this.doCreateMultipleShipment(ResShipments[i]);
          this.shipments = this.shipments.concat(retShipments);
        }
      }
    } else {
      // Old Flow
      var ResShipments = res.filter((x) => { return x.Shipment != null });
      if (ResShipments.length > 0) {
        for (var i = 0; i < ResShipments.length; i++) {
          var c = this.shipments.filter(x => x.Number === ResShipments[i].Number);
          if (c.length > 0) {
            this.toaster.error(`${this.translate.instant('pages.createReceiptPage.shipmentExsist',{
              shipmentNumber: ResShipments[i].Number
            })}`);
          }
          else {
            this.shipments.push(ResShipments[i]);
          }
        }
      }
    }
  }

  filterAlreadyPaidShipment() {
    if(this.isMultiCurrenciesForInbound == false) {
      return this.shipments;
    }
    return this.shipments.filter((shipment) => {
      return shipment.Shipment.CashOnDelivery.Value != 0 || shipment.Shipment.Customs.Value != 0 || shipment.Shipment.RatedPrice.Value != 0
    })
  }

  doCreateMultipleShipment(shipment: any) {
    let chargesCurrency = [shipment.Shipment.CashOnDelivery.Code, shipment.Shipment.Customs.Code, shipment.Shipment.RatedPrice.Code];
    const currencySet = new Set();
    let retShipments = [];

    chargesCurrency.forEach((chargeCurrency: any) => {
      if (this.checkCurrency(chargeCurrency)) {
        currencySet.add(chargeCurrency);
      }
    });

    chargesCurrency = Array.from(currencySet);

    if (chargesCurrency.length == 0 
        && shipment.Shipment.CashOnDelivery.Value == 0 
        && shipment.Shipment.Customs.Value == 0 
        && shipment.Shipment.RatedPrice.Value == 0) {
      chargesCurrency = [this.branchCurrencyCode];

      shipment.Shipment.CashOnDelivery.Code = this.branchCurrencyCode;
      shipment.Shipment.Customs.Code = this.branchCurrencyCode;
      shipment.Shipment.RatedPrice.Code = this.branchCurrencyCode;
    }

    chargesCurrency.forEach((currency) => {
      let tShipment = JSON.parse(JSON.stringify(shipment));;

      if (this.checkCurrency(shipment.Shipment.CashOnDelivery.Code) && shipment.Shipment.CashOnDelivery.Code !== currency) {
        tShipment.Shipment.CashOnDelivery.Code = '';
        tShipment.Shipment.CashOnDelivery.Value = 0;
        tShipment.Shipment.CODCollectionID = 0;
      }

      if (this.checkCurrency(shipment.Shipment.Customs.Code) && shipment.Shipment.Customs.Code !== currency) {
        tShipment.Shipment.Customs.Code = '';
        tShipment.Shipment.Customs.Value = 0;
        tShipment.Shipment.CustomCollectionID = 0;
      }
      
      if (this.checkCurrency(shipment.Shipment.RatedPrice.Code) && shipment.Shipment.RatedPrice.Code !== currency) {
        tShipment.Shipment.RatedPrice.Code = '';
        tShipment.Shipment.RatedPrice.Value = 0;
        tShipment.Shipment.CCCollectionID = 0;
      }
      retShipments.push(tShipment);
    });
    return retShipments;
  }

  getCurrency(shipment) {
    if (this.isMultiCurrenciesForInbound) {
      return this.checkCurrency(shipment.Shipment.CashOnDelivery.Code) ? shipment.Shipment.CashOnDelivery.Code : (
        this.checkCurrency(shipment.Shipment.Customs.Code) ? shipment.Shipment.Customs.Code : shipment.Shipment.RatedPrice.Code
      )
    }
    return '';
  }

  checkCurrency(currency: string) {
    return currency != null && currency.trim() != ''
  }

  change() {
    this.isOpen = true;
  }

  fixDecimals(value: any = 0) {
    if (value != 0) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      return 0;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true)
        this.isOpen = change;
      this.shipments = [];
      this.shipmentNumber = '';
    }
  }

  calculateTotalCharges(Customs, CashOnDelivery, RatedPrice) {
    var totalCharges = 0;
    if (Customs)
      totalCharges += Customs;
    if (CashOnDelivery)
      totalCharges += CashOnDelivery;
    if (RatedPrice)
      totalCharges += RatedPrice;
    return this.fixDecimals(totalCharges);
  }

  setPinNumber(waybillNumber, origin, productGroup, status) {
    this.pinNumber = "";
    this.pinObject = {
      waybillNumber: waybillNumber,
      origin: origin,
      productGroup: productGroup,
      status: status
    }
  }

//******************************************************************//
  OTPNumber = "";
  ShowMessage = false;
  MessageContent = "";
  
  setOTPNumber(waybillNumber, origin, productGroup) {
    this.ShowMessage = false;
    this.MessageContent = "";
    this.OTPNumber = "";
    this.OTPObject = {
      waybillNumber: waybillNumber,
      origin: origin,
      productGroup: productGroup
    }
  }

  validateOTPShipment(e) {
    this.ShowMessage = false;
    this.MessageContent = "";
    if (this.OTPNumber.trim() == "") {
      e.preventDefault();
      this.ShowMessage = true;
      this.showErrors("OTP is Required!");
    }
    var index = this.shipments.findIndex(x => x.Number == this.OTPObject.waybillNumber);
    var OTPShipmentProperty = this.shipments[index].Shipment.OTPShipmentProperty;
    if(OTPShipmentProperty != null){
      if(this.OTPNumber.trim() == OTPShipmentProperty._Value){
        this.shipments[index].Shipment.OTPValidated = true;
         let close: HTMLElement = <HTMLElement>document.querySelector(".close");
         close.click();
         this.hideLoader = true;
         this.toaster.success(`${this.translate.instant('pages.createReceiptPage.inboundAwb.validatedSuccess')}`);  
         //if they need indicator that the otp is valid u can add it here.**************
      }else{
        e.preventDefault();
        this.ShowMessage = true;
        this.showErrors(`${this.translate.instant('pages.createReceiptPage.inboundAwb.invalidOtp')}`);
        //I think u need to reset the input********* chrck with testing!
      }
    }else{
         this.hideLoader = true;
         this.ShowMessage = true;
         this.showErrors(`${this.translate.instant('pages.createReceiptPage.inboundAwb.otpShipmentPropertyNull')}`);
    }
  }
  showErrors(MessageContent) {
   this.MessageContent = MessageContent;
  }


  removeShipment(shipment) {
    var index = this.shipments.indexOf(shipment)
    if (index > -1) {
      this.shipments = this.shipments.filter((x) => x?.Number != shipment?.Number);
    }
  }
  resendPin = "";
  hideLoader = true;
  resendPinSmartShipment() {
    this.resendPin = "disabled"
    this.hideLoader = false
    this.shipmentDetails.SmartResendPin({
      "ShipmentNumber": this.pinObject.waybillNumber,
      "Origin": this.pinObject.origin,
      "ProductGroup": this.pinObject.productGroup
    },
      (res) => {
        this.resendPin = "";
        this.hideLoader = true;
        this.toaster.success(`${this.translate.instant('pages.createReceiptPage.inboundAwb.pinNumberSent')}`)
      },
      (err) => {
        this.resendPin = "";
        this.hideLoader = true;
        this.toaster.error(err.error[0].Message)
       
    })
  }
  pinNumber = "";
  showPinNumberIsRequired = false
  validateSmartShipment() {
    if (this.pinNumber.trim() == "") {
      this.showPinNumberIsRequired = true;
      return;
    }
    this.hideLoader = false
    this.shipmentDetails.validateSmartPinNumber({
      "ShipmentNumber": this.pinObject.waybillNumber,
      "Origin": this.pinObject.origin,
      "ProductGroup": this.pinObject.productGroup,
      "PinNumber": this.pinNumber,
    }, (res) => {
        this.pinObject;
        var index = this.shipments.findIndex(x => x.Number == this.pinObject.waybillNumber);
        this.shipments[index].Shipment.validated = true;
        let close: HTMLElement = <HTMLElement>document.querySelector(".close");
        close.click();
        this.hideLoader = true;
        this.toaster.success(`${this.translate.instant('pages.createReceiptPage.inboundAwb.validated')}`)
    }, (err) => {
        this.hideLoader = true;
        this.toaster.error(err.error[0].Message)
    })
    
  }
  
  ngOnInit() {

  }
}
